import { Type } from '@angular/core';
import { HttpAdapter } from '@freelancer/freelancer-http';
import * as Rx from 'rxjs';
import { RequestDataOptions } from './request-data';

/** Auth user ID for logged-out use of the datastore */
export const LOGGED_OUT_KEY = '0';

export interface DatastoreConfig {
  readonly webSocketUrl: string;
  readonly enableStoreFreeze: boolean;
  readonly httpAdapter: Type<HttpAdapter>;
  readonly requestData: RequestDataOptions;
  readonly backendScheduler?: Rx.SchedulerLike;
}
